import { Vehicle } from '../models/Vehicle'
import { api } from './api'

interface VehiclesResponse {
    vehicles: Vehicle[]
    availableBrands: string[]
    availableRanks: number[]
}

export class DriftService {
    private static lastRequest: Date = new Date('1971-01-01')

    static async start(): Promise<void> {
        if (new Date().getTime() - this.lastRequest.getTime() < 500) return
        this.lastRequest = new Date()
        await api.post("/drift/listening/start", {})
    }

    static async stop(): Promise<void> {
        if (new Date().getTime() - this.lastRequest.getTime() < 500) return
        this.lastRequest = new Date()
        await api.post('/drift/listening/stop', {})
    }
}